<template>
    <div class="icons">
        <span v-if="isAuthenticated && image.user == username">
            <router-link :to="{ name: 'image' , params: { id: image.user, image_id: image.pk, edit: true }}">
                <v-icon >$vuetify.icons.editoutline</v-icon>
            </router-link>
        </span>

        <span v-if="$can(['add'], 'api/vote') && isAuthenticated && image.user != username && !image.voted">
            <button class="btn btn-success" @click="voteImage(image.pk)">
                <v-icon>$vuetify.icons.flagoutline</v-icon> 
                <v-icon>$vuetify.icons.bookmarkoutline</v-icon> 
                <v-icon>$vuetify.icons.heartoutline</v-icon>
            </button>
        </span>
        
        <span v-if="isAuthenticated && image.user != username && image.voted">
            <v-icon>$vuetify.icons.flag</v-icon>
            <v-icon>$vuetify.icons.bookmark</v-icon>
            <v-icon>$vuetify.icons.heart</v-icon>
        </span>
    </div>  
</template>

<script>
import { mapActions } from 'vuex'
import { userMixin } from '@/functions/mixins'

export default {
  name: 'Icons',
  props: {
      image: Object,
  },
  mixins: [userMixin],
  methods: {
      ...mapActions('image', ['voteImage'])
  }
};
</script>